import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebaseConfig";

// runway_test 컬렉션에서 데이터 불러오기
export const getRunwayTestData = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "runway_test"));

    const data = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      name: doc.name,
      title: doc.title,
      ...doc.data(),
    }));

    return { success: true, data };
  } catch (error) {
    console.error("데이터 불러오기 에러:", error.message);
    return { success: false, error: error.message };
  }
};
